const titleHeaderEvent = {
  text: 'Day'
};

export default titleHeaderEvent;
